import React, { useEffect} from 'react';

/** 
 * @param {any} props Component props
 * @param {boolean} props.reload should the QSI api be reloaded
 * @param {string} props.class class names to effect default display not used if props.children exist
 * @param {string} props.id the id that will be used by qualtrics to react to
 * @param {string} props.message to use for default display ignored if props has children
 * */
const QualtricsClickToLaunch = (props) => {
    useEffect(() => {
        const reload = props.reload || false;
        try {
            if (reload) {
                QSI.API.unload();
                QSI.API.load().then(QSI.API.run());
                console.info(`QualtricsClickToLuanch LOADED`);
            } else {
                console.info(`QualtricsClickToLaunch OPTED TO NOT RELOAD`);
            }
        } catch (e) { console.error(`QualtricsClickToLuanch error`, e);}
    }, []);

    return props.enabled && <div className={`qualtrics-click-to-luanch ${props.children ? '' : 'card-between'} ${props.class ? props.class : ''}`}>
        {props.children ? props.children :
            <a id={props.id} className="card-link" >{props.message}</a>}
    </div>;
}

export default QualtricsClickToLaunch;





